import request from '@/util/http'

//获得用户菜单
export function GetMenu() {
    return request({
        url: '/admin/menu',
        method: 'get'
    })
}

export function fetchMenuTree(query) {
    return request({
        url: '/admin/menu/tree',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/admin/menu',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/admin/menu/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/admin/menu/' + id,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/admin/menu',
        method: 'put',
        data: obj
    })
}
//获取菜单管理BI
export function getBiObj(query) {
    return request({
        url: '/admin/menu/cockpits',
        method: 'get',
        params: query
    })
}

//获取菜预览URL
    export function previewUrl(query) {
        return request({
            url: '/admin/menu/preview',
            // url: '/menu/preview',
            method: 'put',
            data: query
        })
    }

//获取动态参数
export function dynamicParams(query) {
    return request({
        url: '/admin/menu/dynamicParams',
        // url: 'menu/dynamicParams',
        method: 'get',
        // params: query
    })
}
